if (!customElements.get('fm-system-essentials')) {
 customElements.define('fm-system-essentials', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.copy = JSON.parse(this.querySelector('[data-strings]').textContent);
   this.form = this.querySelector('form');
   this.bundleInputs = this.bundleInputs || this.querySelector('[data-bundle-inputs]');
   document.body.appendChild(this.bundleInputs);
   this.button = this.form.querySelector('[type=submit]');
   this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
   this.rows = [...this.querySelectorAll('[data-essential]')].map(el => ({el, key:el.dataset.essential, products:JSON.parse(el.querySelector('[data-products]').textContent), pick:el.querySelector('[data-pick]'), productSelect:el.querySelector('[data-product]'), fields:el.querySelector('[data-option-fields]'), qty:el.querySelector('[data-quantity]'), values:[]}));
   this.rows.forEach(row => this.chooseProduct(row));
   this.addEventListener('change', event => {
    const row = this.rows.find(r => r.el.contains(event.target));
    if (!row) return;
    if (event.target === row.pick && row.pick.checked && row.el.dataset.lane) {
     this.rows.filter(r => r !== row && r.el.dataset.lane === row.el.dataset.lane).forEach(r => {r.pick.checked = false;});
    }
    if (event.target === row.productSelect) this.chooseProduct(row);
    if (event.target.matches('[data-option-index]')) {
     const index = Number(event.target.dataset.optionIndex);
     row.values[index] = event.target.value;
     row.values.fill('', index + 1);
     this.renderOptions(row);
    }
    this.update();
   }, {signal});
   this.addEventListener('input', event => {if (event.target.matches('[data-quantity]')) this.update();}, {signal});
   this.form.addEventListener('submit', event => {
    this.update();
    if (!this.valid) {event.preventDefault(); event.stopImmediatePropagation(); return;}
    this.pending = true;
   }, {capture:true, signal});
   document.addEventListener('ajaxProduct:added', () => {
    if (!this.pending) return;
    this.pending = false;
    this.rows.forEach(row => {row.pick.checked = false;});
    this.update();
    this.querySelector('[data-essentials-status]').textContent = this.copy.added;
   }, {signal});
   document.addEventListener('ajaxProduct:error', () => {this.pending = false;}, {signal});
   this.mainForm = this.closest('product-info')?.querySelector('form.product-form');
   this.mainForm?.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (variant) {this.dataset.outlets = variant.option1 || variant.options?.[0] || ''; this.dataset.barb = variant.option3 || variant.options?.[2] || ''; this.syncKit();}
   }, {signal});
   this.closest('product-info')?.addEventListener('change', event => {if (event.target.name === 'quantity' && event.target.form === this.mainForm) this.syncKit();}, {signal});
   this.syncKit();
  }
  disconnectedCallback() {this.abort?.abort(); this.abort = null; this.bundleInputs?.remove();}
  chooseProduct(row) {
   row.product = row.productSelect ? row.products.find(p => String(p.id) === row.productSelect.value) : row.products[0];
   row.values = [];
   const product = row.product || row.products[0];
   const img = row.el.querySelector('img');
   if (img) {img.src = product.image; img.removeAttribute('srcset');}
   row.el.querySelector('[data-product-link]').href = product.url;
   this.renderOptions(row);
  }
  renderOptions(row) {
   row.fields.replaceChildren();
   if (!row.product) return;
   row.product.options.forEach((name,index) => {
    const matches = row.product.variants.filter(v => row.values.slice(0,index).every((value,i) => !value || v.options[i] === value));
    const values = [...new Set(matches.map(v => v.options[index]))];
    if (!values.includes(row.values[index])) row.values[index] = '';
    if (values.length === 1) row.values[index] = values[0];
    if (values.length === 1 && row.product.variants.length === 1) return;
    const wrap = document.createElement('div');
    const label = document.createElement('label');
    const select = document.createElement('select');
    select.id = row.pick.id + '-option-' + index;
    select.dataset.optionIndex = index;
    label.htmlFor = select.id;
    label.textContent = row.key === 'controller' ? this.copy.length : name;
    select.add(new Option(this.copy.choose,''));
    values.forEach(value => {
     const available = matches.some(v => v.options[index] === value && v.available);
     const option = new Option(value + (available ? '' : ' — ' + this.copy.sold_out),value);
     option.disabled = !available;
     select.add(option);
    });
    select.value = row.values[index] || '';
    wrap.append(label,select); row.fields.append(wrap);
   });
  }
  syncKit() {
   if (this.dataset.kind === 'reroute') {
    const row = this.rows.find(r => r.key === 'kit');
    const count = {single:1,dual:2,triple:3,quad:4}[this.dataset.outlets.toLowerCase()] || 1;
    const normalize = value => String(value).replace(/["″]/g,'').trim();
    const variant = row?.product?.variants.find(v => normalize(v.options[0]) === normalize(this.dataset.barb));
    if (row) {
     if (variant) row.values = [...variant.options];
     row.qty.value = count * (Number(this.mainForm?.elements.namedItem('quantity')?.value) || 1);
     this.renderOptions(row);
    }
   }
   this.update();
  }
  update() {
   const items = [];
   let total = 0, selected = 0, incomplete = 0;
   this.rows.forEach(row => {
    const chosen = row.pick.checked;
    row.el.classList.toggle('is-selected', chosen);
    row.pick.setAttribute('aria-expanded',String(chosen));
    row.el.querySelector('[data-options]').hidden = !chosen;
    row.el.querySelectorAll('[data-options] select,[data-options] input').forEach(input => {input.disabled = !chosen;});
    const variant = row.product?.variants.find(v => v.options.every((value,index) => value === row.values[index]));
    if (variant) {row.qty.min = variant.min || 1; row.qty.step = variant.step || 1; if (variant.max == null) row.qty.removeAttribute('max'); else row.qty.max = variant.max;}
    const quantity = Number(row.qty.value), min = Number(row.qty.min) || 1, step = Number(row.qty.step) || 1, max = Number(row.qty.max) || Infinity;
    const validQuantity = Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
    let message = '';
    if (!variant) message = this.copy.options;
    else if (!variant.available) message = this.copy.unavailable;
    else if (!validQuantity) message = this.copy.quantity;
    if (row.key === 'kit' && variant) {
     const normalize = value => String(value).replace(/["″]/g,'').trim();
     if (normalize(variant.options[0]) !== normalize(this.dataset.barb)) message = this.copy.kit_match;
     else if (!variant.available) message = this.copy.kit_sold_out;
    }
    if (row.key === 'controller' && this.dataset.kind === 'reroute') {
     const engines = {single:1,dual:2,triple:3,quad:4}[this.dataset.outlets.toLowerCase()] || 1;
     if (engines > 2 && row.product?.handle === 'flushmaster-2-outlet') message = this.copy.capacity;
    }
    row.el.querySelector('[data-row-message]').textContent = chosen ? message : '';
    const lowPrice = row.product?.price ?? Math.min(...row.products.map(p => p.price));
    row.el.querySelector('[data-row-price]').textContent = variant ? this.money.format(variant.price * (chosen && validQuantity ? quantity : 1) / 100) : this.copy.from + ' ' + this.money.format(lowPrice / 100);
    if (chosen) {
     selected++;
     if (message) incomplete++;
     else {items.push({id:variant.id, quantity}); total += variant.price * quantity;}
    }
   });
   this.valid = selected > 0 && incomplete === 0;
   this.button.disabled = !this.valid;
   const idInput = this.form.querySelector('[name=id]');
   idInput.value = items[0]?.id || '';
   this.form.querySelector('[name=quantity]').value = items[0]?.quantity || 1;
   const bundleInputs = this.bundleInputs;
   bundleInputs.replaceChildren();
   items.slice(1).forEach(item => {
    const input = document.createElement('input');
    input.type = 'checkbox'; input.name = 'bundles'; input.checked = true; input.value = item.id; input.dataset.min = item.quantity;
    bundleInputs.append(input);
   });
   this.querySelector('[data-essentials-total]').textContent = incomplete ? this.copy.incomplete : this.money.format(total / 100);
   this.querySelector('[data-essentials-status]').textContent = incomplete ? this.copy.finish : this.copy.status;
  }
 });
}
